import React, { Component } from "react";

import Server from "./../Server.js";
import { connect } from "react-redux";

class Inquiry extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();

    this.state = {
    };
  }
  componentDidMount() {
    let param = {
      token: localStorage.getItem("api_token"),
    };
    this.setState({
      loading: 1,
    });
    let that = this;
    let SCallBack = function (response) {
      that.setState({
        user_Id: response.data.authData.userId,
        loading: 0,
      });
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
      console.log(error);
    };
    this.Server.send("MainApi/checktoken", param, SCallBack, ECallBack);
  }

  getInfo(){
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      type: "",
      nationalCode: this.state.nationalCode,
    };
    let SCallBack = function (response) {
    };
    let ECallBack = function (error) {
    }
    this.Server.send("CompanyApi/getInquiry", param, SCallBack, ECallBack)
  }

  render() {
    return (
      <div style={{ direction: "rtl" }}>
        <form>

<div className="row">
  <div className="col-lg-6 col-12">
    <div className="group">
      <input className="form-control irsans" style={{maxWidth:350}} autoComplete="off" type="text" value={this.state.number} name="number" onChange={(event) => this.setState({ nationalCode: event.target.value })} required="true" />
      <label>کد ملی / شناسه ملی </label>
    </div>
  </div>
  <div className="col-lg-12 col-12">
        <button className="btn btn-primary irsans" onClick={()=>{
            this.getInfo();
        }} style={{ width: "200px", marginTop: "20px", marginBottom: "20px" }}> دریافت اطلاعات </button>

      </div>
  </div>
  </form>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  };
};
export default connect(mapStateToProps)(Inquiry);
